/** Roles whose passwords cannot be reset by other admins */
export const PROTECTED_ROLES = new Set(['admin', 'superadmin']);

/**
 * Canonical account statuses. Mirrors the FinProAdminServer `AccountStatus` enum
 * (app/core/enums/account-status.ts) — the single source of truth for status strings.
 */
export const ACCOUNT_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  LOCKED: 'LOCKED',
  DEACTIVE: 'DEACTIVE',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  REJECTED: 'REJECTED',
} as const;

/**
 * The backend writes TWO distinct "admin-disabled" values that mean the same thing to the UI:
 *   - INACTIVE — written by the admin deactivate action (updateUserStatus)
 *   - DEACTIVE — written by the login lock-escalation path (too many failed logins)
 * The server itself treats them as equivalent (account-lock-util.ts). Both must show "Activate".
 */
export const DISABLED_STATUSES: ReadonlySet<string> = new Set([
  ACCOUNT_STATUS.INACTIVE,
  ACCOUNT_STATUS.DEACTIVE,
]);

/**
 * Normalize a raw backend status to canonical uppercase, absorbing casing drift
 * (e.g. the MFA OTP-failure path writes lowercase 'locked' while password login writes 'LOCKED').
 */
export function normalizeStatus(raw: string | number | null | undefined): string {
  return String(raw ?? '').trim().toUpperCase();
}
